import {computed, inject, Injectable, signal, WritableSignal} from '@angular/core';
import {AuthInfo} from "../../models/auth-info";
import {LoggerService} from "../../services/logger/logger-service/logger.service";
import {AuthService} from "../auth-service.interface";
import {Router} from "@angular/router";

/**
 * Provides mock methods for logging user in and out.
 */
@Injectable({
  providedIn: 'root'
})
export class AuthServiceMock implements AuthService {
  // Injectables
  private logger = inject(LoggerService);
  private router = inject(Router);

  // Hide writable signal from consumers
  private _user: WritableSignal<AuthInfo | null> = signal(null);

  // Expose non-writable signal
  user = computed(() => this._user());
  name = computed(() => this._user()?.name ?? null);

  private token: string = '';

  constructor() {
    this.login();
  }

  login() {
    this.logger.debug('mock auth login triggered')
    this._user.set({
      name: "Test Admin :)"
    });
  }

  logout() {
    alert("This is a mock - you can't logout :)");
  }

  isLoggedIn(): boolean {
    return this.user() !== null;
  }

  setupSubscriptions(): void {
  }

  getToken(): string {
    return this.token;
  }

  setToken(token: string): void {
    this.token = token;
  }
}
